import { API } from "src/config/api";

export const toFarsiNumber = (value = "") => {
  let nVal = value.toString();
  const enNum = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
  const FaNum = ["۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹", "۰"];

  for (let i = 0, numbersLen = enNum.length; i < numbersLen; i++) {
    nVal = nVal.replace(new RegExp(enNum[i], "g"), FaNum[i]);
  }
  return nVal;
};

export const numberWithCommas = (number) => {
  if (!number) return;
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const currency = (value, showUnit = true) => {
  if (!value) {
    return showUnit ? "۰ ریال" : "۰";
  }

  value = value
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    .split("")
    .reverse()
    .join("");

  if (showUnit) {
    value += " ریال";
  }
  return toFarsiNumber(value);
};

export const isValidPhoneNumber = (value) => {
  const regex = new RegExp("^(\\+98|0)?9\\d{9}$");
  const result = regex.test(value);
  return result;
};

export const setApiHeaders = (obj) => {
  API.defaults.headers.common["ctx"] = JSON.stringify(obj);
};

export const shamsi2Miladi = (timeStamp) => {
  var parts = timeStamp.split(/\/| /);
  var jy, jm, jd;
  jy = parseInt(parts[0]);
  jm = parseInt(parts[1]);
  jd = parseInt(parts[2]);
  var sal_a, gy, gm, gd, days;
  jy += 1595;
  days =
    -355668 +
    365 * jy +
    ~~(jy / 33) * 8 +
    ~~(((jy % 33) + 3) / 4) +
    jd +
    (jm < 7 ? (jm - 1) * 31 : (jm - 7) * 30 + 186);
  gy = 400 * ~~(days / 146097);
  days %= 146097;
  if (days > 36524) {
    gy += 100 * ~~(--days / 36524);
    days %= 36524;
    if (days >= 365) days++;
  }
  gy += 4 * ~~(days / 1461);
  days %= 1461;
  if (days > 365) {
    gy += ~~((days - 1) / 365);
    days = (days - 1) % 365;
  }
  gd = days + 1;
  sal_a = [
    0,
    31,
    (gy % 4 === 0 && gy % 100 !== 0) || gy % 400 === 0 ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ];
  for (gm = 0; gm < 13 && gd > sal_a[gm]; gm++) gd -= sal_a[gm];
  return new Date([gy + "/" + gm + "/" + gd] + " " + parts[3]);
};

export const convertArtoPr = (str) => {
  let string = str;
  const diff = {
    ة: "ه",
    ك: "ک",
    دِ: "د",
    بِ: "ب",
    زِ: "ز",
    ذِ: "ذ",
    شِ: "ش",
    سِ: "س",
    ى: "ی",
    ي: "ی",
    ئ: "ی",
    "٠": "۰",
    "١": "۱",
    "٢": "۲",
    "٣": "۳",
    "٤": "۴",
    "٥": "۵",
    "٦": "۶",
    "٧": "۷",
    "٨": "۸",
    "٩": "۹",
  };
  Object.entries(diff).map(
    ([key, value]) => (string = string.replaceAll(key, value))
  );
  return string;
};

export const insert = (arr, index, newItem) => [
  ...arr.slice(0, index),
  newItem,
  ...arr.slice(index),
];

export const strFieldExtractor = (str) => {
  const array = [];
  var patt = /<\/?[a-z][^>]*>/gi;
  const match = str.match(patt);
  match &&
    match
      .filter((input) => input.includes("input") && input)
      .map((input, index) => {
        array.push({ input });
      });
  return array;
};
